import { BaseResponse, request } from "~/lib/request";
import { MemberLevel } from "~/routes/$lang/profile/-api";

export enum PaymentChannel {
	None = "PaymentChannelNone",
	Web3 = "PaymentChannelWeb3",
	AliPayMobile = "PaymentChannelAliPayMobile",
	AliPayPC = "PaymentChannelAliPayPC",
	WechatPayMobile = "PaymentChannelWechatPayMobile",
	WechatPayPC = "PaymentChannelWechatPayPC",
	Stripe = "PaymentChannelStripe",
	XenditCard = "PaymentChannelXenditCard",
	XenditQrCode = "PaymentChannelXenditQrCode",
	ApplePay = "PaymentChannelApplePay",
	GooglePay = "PaymentChannelGooglePay",
	Segpay = "PaymentChannelSegpay",
}

export enum BillingCycle {
	None = "None",
	Daily = "Daily",
	WeekLy = "WeekLy",
	Monthly = "Monthly",
	Quarterly = "Quarterly",
	SemiAnnual = "SemiAnnual",
	Yearly = "Yearly",
}

export interface OrderProduct {
	currency_name: string;
	currency_symbol: string;
	desc: string;
	discount_info: string;
	id: string;
	name: MemberLevel;
	price: number;
	product_amount: number;
	type: "Once" | "Subscription";
	billing_cycle: BillingCycle;
}

export interface CreateOrderResponse {
	order_id: string;
	web3_order_details?: {
		tx_hash: string;
	};
	stripe_order_details?: {
		pay_url: string;
	};
}
interface OrderProductsResponse {
	products: OrderProduct[];
	supported_channels: string[];
}

export const getOrderProducts = async (): Promise<
	BaseResponse<OrderProductsResponse>
> => {
	return await request.get("/aifk/order/products");
};

interface CreateOrderParams {
	product_id: string;
	payment_channel: PaymentChannel;
	stripe_success_url?: string;
	stripe_cancel_url?: string;
}

export const createOrder = async (
	params: CreateOrderParams,
): Promise<BaseResponse<CreateOrderResponse>> => {
	return await request.post("/aifk/order/create", params);
};

export const getOrderByOrderId = async (
	order_id: string,
): Promise<BaseResponse<{ order: OrderProduct }>> => {
	return await request.get("/aifk/order/by/id", {
		order_id,
	});
};
export interface SubscriptionInfoResponse {
	subscription_info: {
		sub_id: string;
		product_info: OrderProduct;
		billing_cycle: BillingCycle;
		start_at: number;
		end_at: number;
	};
}
export const getSubscriptionInfo = async (): Promise<
	BaseResponse<SubscriptionInfoResponse>
> => {
	return await request.get("/aifk/order/subscription/info");
};

// /aifk/order/info/by/user
export const getOrderInfoByUser = async (): Promise<
	BaseResponse<{ stripe_info: { payment_method_id: string } }>
> => {
	return await request.get("/aifk/order/info/by/user");
};

export interface CreateSubscriptionOrderResponse {
	subscription_id: string;
	stripe_order_details: {
		pay_url: string;
	};
}
export const createSubscriptionOrder = async (
	params: CreateOrderParams,
): Promise<BaseResponse<CreateSubscriptionOrderResponse>> => {
	return await request.post("/aifk/order/subscription/create", params);
};
